import React, { useState, useEffect, useCallback } from 'react';
import { Button, Label, FormGroup, CustomInput } from '@polichat/flamboyant';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ChatActions from '../../../../../store/modules/chat/actions';
import Animation from '../../../../common/animation';
import { useGlotaT } from 'src/hooks/useGlotaTranslation';
import {
  Icon,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledTooltip,
  Badge,
} from '@polichat/flamboyant';

import {
  handleMergeDepartmentToUsers,
  removeAccentString,
} from '../../../../../store/modules/chat/functions';

import InputSearch from '../../../../common/form/InputSearch';

import Avatar from '../../../../common/profile/Avatar';
import checkAvatar from '../../../../../utils/checkAvatar';

import { useSummarize } from 'src/components/common/Summary/hooks/useSummarize';
import { subDays } from 'date-fns';
import { useFlags } from 'flagsmith/react';
import { customUseFlags } from 'src/hooks/customUseFlags';
import { useUserPreferences } from 'src/hooks/useUserPreferences';
import { Close, Info } from '@poli-digital/react';
import { Modal } from 'reactstrap';

// Array de formatação dos DropItems
let usersToShow = [];

var pageFull = 1;
var loading = false;

function TransferChatModal({
  chat,
  transferChatRequest,
  closeTransferChatModal,
  allOperators,
  allDepartments,
  currentUser,
  isOpen,
}) {
  const [observerScroll, setObserverScroll] = useState(false);
  const [loadingListTop, setLoadingListTop] = useState(false);
  const [loadingListDown, setLoadingListDown] = useState(false);
  const limitePage = 4;

  const sortByName = (a, b) => {
    if (a.name < b.name) return -1;
    if (a.name > b.name) return 1;
    return 0;
  };

  // Ordenando por nome
  const allOperatorsSort = React.useMemo(() => {
    return [...(allOperators || [])].sort(sortByName);
  }, [allOperators]);
  const usersOriginal = React.useMemo(() => {
    if (!currentUser) return allOperatorsSort;

    const blockedRedirect = currentUser?.blocked_redirect == 1;

    if (blockedRedirect) {
      return allOperatorsSort.filter(
        (e) => e.available_service == 1 && e.status == 1
      );
    }

    return allOperatorsSort;
  }, [allOperatorsSort, currentUser]);
  const [users, setUsers] = useState(usersOriginal);

  useEffect(() => {
    setUsers(usersOriginal);
  }, [usersOriginal]);

  const [departmentsMergedWithUsers, setDepartmentsMergedWithUsers] = useState([]);

  /**
   * Criando o array que contem departamento e usuarios separados
   * Apenas se existirem departamentos na empresa
   */
    useEffect(() => {
      if (!currentUser) return;

      if (allDepartments?.length > 0 && users?.length > 0) {
        const merged = handleMergeDepartmentToUsers(
          allDepartments,
          users,
          currentUser
        );
        setDepartmentsMergedWithUsers(merged);
      }
    }, [allDepartments, users, currentUser]);
  /* End */

  /**
   * Monitora o scroll da lista de transferencia
   */
  useEffect(() => {
    const ref = document.getElementById('listTransferScroll');
    if (ref && usersToShow?.length > 0 && observerScroll) {
      ref.addEventListener('scroll', (evt) => {
        let sizeHeightContainer = ref.offsetHeight; // tamanho do container visível para o usuário
        let sizeHeightContainerScroll = evt.target.scrollHeight; // tamanho do container inteiro de mensagens
        let scrollTop = evt.target.scrollTop; // quantidade de px foram rolados em uma transição

        const topPage = scrollTop === 0;
        const endPage =
          scrollTop + sizeHeightContainer >= sizeHeightContainerScroll;

        if (topPage) goPage(true);
        if (endPage) goPage();
      });
    }
  }, [observerScroll, usersToShow?.length]);

  /**
   * Encrementa mais uma pagina e coloca loading para nao ter loop infinito
   */
  const goPage = (top) => {
    if (!loading) {
      /**
       * Logica subir
       */
      if (top && pageFull >= limitePage) {
        loadingListPage(top);
        pageFull -= 1;

        setTimeout(() => {
          const ref = document.getElementById('listTransferScroll');
          if (ref) ref.scrollTop = 100;
        }, 600);
      }

      /**
       * Logicar descer
       */
      if (!top && pageFull < usersToShow?.length) {
        loadingListPage();
        pageFull += 1;
      }
    }
  };

  const loadingListPage = (top) => {
    if (top) setLoadingListTop(true);
    else setLoadingListDown(true);

    loading = true;

    setTimeout(() => {
      if (top) setLoadingListTop(false);
      else setLoadingListDown(false);

      loading = false;
    }, 500);
  };
  /* End */

  /**
   * Montando a lista
   */
  useEffect(() => {
    /**
     * Redefinindo as configurações ao abrir modal
     */
    usersToShow = [];
    pageFull = 1;
    loading = false;
    const perPage = 25;

    /**
     * Scrool ficava no meio
     */
    const ref = document.getElementById('listTransferScroll');
    if (ref) ref.scrollTop = 0;

    if (
      departmentsMergedWithUsers &&
      departmentsMergedWithUsers.length > 0 &&
      allDepartments &&
      allDepartments.length > 0
    ) {
      const render = [];

      /**
       * Departamentos com seus usuarios
       */
      departmentsMergedWithUsers.map((element, counterFiltered) => {
        /**
         * Montando componente
         * Departamento
         */
        render.push(
          <React.Fragment
            key={`department-name-${element.department.id}-${counterFiltered}`}
          >
            {element.department.usersWithoutDept && (
              <div>
                <span
                  className="departmentDropdown transfer-chat-margin"
                  title={attendantsWithoutDepartmentInfoText}
                >
                  <Badge color="warning" pill className="text-white">
                    Novo
                  </Badge>
                </span>
              </div>
            )}

            <span
              className="departmentDropdown transfer-chat-margin"
              title={
                element.department.usersWithoutDept
                  ? allAttendantsWithoutDepartmentText
                  : ''
              }
            >
              {element.department.name}
            </span>
            <DropdownItem divider></DropdownItem>
          </React.Fragment>
        );

        /**
         * Se Departamento nao tiver usuario
         */
        if (element?.users?.length === 0) {
          render.push(
            <p
              className="transfers-name text-center"
              key={`user-not-exist-${element.department.id}-${counterFiltered}`}
            >
              --
            </p>
          );
        }

        /**
         * Montando componente
         * Usuarios do departamento
         */
        element?.users?.sort(sortByName).map((user, index) => {
          render.push(
            <DropdownItem
              key={`list-${user.id}+${counterFiltered}-${index}`}
              className="transfer-options-names"
              value={user.id}
              onClick={() => {
                setOperator(user.id);
                if (element.department.id) setDepartment(element.department.id);
              }}
            >
              <div className="d-flex align-items-center justify-content-start gap-2 text-truncate">
                <Avatar
                  className="operator"
                  title={user.name}
                  url={checkAvatar(user.name, user.picture)}
                  size={23}
                  extraClass="transfer-options-avatar"
                />{' '}
                <span className="transfers-name">{user.name}</span> {''}
              </div>
              {statusUserList(user)}
            </DropdownItem>
          );
        });
        /* End - Montando componente */
      });
      /* End - Usuarios do departamento */

      /**
       * Dividindo Array para nao carregar a lista de uma vez;
       */
      usersToShow = new Array(Math.ceil(render.length / perPage))
        .fill()
        .map((_) => render.splice(0, perPage));
    } else if (users && users.length) {
      /**
       * Caso a empresa não tenha departamentos
       * Necessário possuir usuários
       */
      /**
       * Dividindo Array para nao carregar a lista de uma vez;
       */
      const _users = [...users];
      const _usersArrayList = new Array(Math.ceil(_users.length / perPage))
        .fill()
        .map((_) => _users.splice(0, perPage));

      /**
       * Montando componente
       * Usuarios
       */
      _usersArrayList.map((ele, key) => {
        const render = ele.map((user, index) => {
          return (
            <DropdownItem
              key={`key${key}-index${index}-user${user.id}`}
              value={user.id}
              className="dropItem-filters"
              onClick={(e) => setOperator(e.target.value)}
            >
              <Avatar
                className="operator"
                title={user.name}
                url={checkAvatar(user.name, user.picture)}
                size={23}
                extraClass="transfer-options-avatar"
              />

              {user.name.split(' ')[0]}

              {statusUserList(user)}
            </DropdownItem>
          );
        });

        usersToShow.push(render);
      });
      /* End - Montando componente */
    }
    /* End - Caso a empresa não tenha departamentos */
  }, [departmentsMergedWithUsers?.length, allDepartments?.length, users]);

  // Traduções para statusUserList
  const unavailableStatusText = useGlotaT('spa.chat.unavailable');
  const availableStatusText = useGlotaT('spa.chat.available');
  const disconnectedStatusText = useGlotaT('spa.chat.offline');
  const attendantsWithoutDepartmentInfoText = useGlotaT('spa.chat.filters.attendantsWithoutDepartmentInfo');
  const allAttendantsWithoutDepartmentText = useGlotaT('spa.chat.filters.allAttendantsWithoutDepartment');
  const insufficientMessagesForSummaryText = useGlotaT('spa.chat.systemMessages.insufficientMessagesForSummary');

  const statusUserList = (user) => {
    return (
      <>
        {user.available_service !== 1 && user.status === -1 ? (
          <>
            <Icon
              id="indisponivel"
              icon={'poli-icon pi-point-fill'}
              size={15}
            />
            <UncontrolledTooltip placement="top" target="indisponivel">
              {unavailableStatusText}
            </UncontrolledTooltip>
          </>
        ) : user.status === 1 ? (
          <>
            <Icon id="online" icon={'poli-icon pi-point-fill'} size={15} />
            <UncontrolledTooltip placement="top" target="online">
              {availableStatusText}
            </UncontrolledTooltip>
          </>
        ) : (
          <>
            <Icon id="offline" icon={'poli-icon pi-point-fill'} size={15} />
            <UncontrolledTooltip placement="top" target="offline">
              {disconnectedStatusText}
            </UncontrolledTooltip>
          </>
        )}
      </>
    );
  };

  /* end - Montando a lista */

  const opennedChat = chat?.chats?.find((chat) => chat.open === true);
  const isFetchingData =
    usersToShow?.length > 0 ? false : opennedChat.transfer_chat_modal_loading;

  const showWalletOptions = chat?.config?.general?.has_wallet === 1;
  //PS-961
  const [selectedOperator, setOperator] = useState(null);
  /*
  const [selectedOperator, setOperator] = useState(
    users?.length ? users[0].id : null
  );
  */
  //PS-961

  const [selectedUserName, setSelectedUserName] = useState('');
  const [selectedDepartment, setDepartment] = useState(null);

  const [walletOption, setWalletOption] = useState(
    showWalletOptions ? 0 : null
  );

  const flag = useFlags(['ia_fowarding_with_resume']);
  const ia_fowarding_with_resume = customUseFlags(
    flag.ia_fowarding_with_resume
  );

  const {
    forwardChatWithSummary,
    updateSummary,
    loading: loadingSummary,
    getSummary,
  } = useUserPreferences();

  const [transferWithSummary, setTransferWithSummary] = useState(false);

  const [textAreaValue, setTextAreaValue] = useState('');
  const [initialTextAreaValue, setInitialTextAreaValue] = useState('');
  const [summary, setSummary] = useState(null);
  const [summaryError, setSummaryError] = useState({
    status: 200,
    message: '',
  });

  // Traduções
  const forwardChatText = useGlotaT('spa.chat.actions.forwardChat');
  const attendantsText = useGlotaT('spa.chat.modals.attendants');
  const checkForwardingInfoText = useGlotaT('spa.chat.modals.checkForwardingInfo');
  const selectAttendantToForwardText = useGlotaT('spa.chat.modals.selectAttendantToForward');
  const searchingText = useGlotaT('spa.chat.modals.searching');
  const noResultsFoundText = useGlotaT('spa.chat.modals.noResultsFound');
  const noAttendantsRegisteredText = useGlotaT('spa.chat.modals.noAttendantsRegistered');
  const waitLoadingInfoText = useGlotaT('spa.chat.modals.waitLoadingInfo');
  const aiSummaryText = useGlotaT('spa.chat.modals.aiSummary');
  const forwardWithSummaryText = useGlotaT('spa.chat.modals.forwardWithSummary');
  const summaryTooltipText = useGlotaT('spa.chat.modals.summaryTooltip');
  const walletRedirectText = useGlotaT('spa.chat.modals.walletRedirect');
  const toUserWalletText = useGlotaT('spa.chat.modals.toUserWallet');
  const duplicateUserWalletText = useGlotaT('spa.chat.modals.duplicateUserWallet');
  const doNotMoveWalletText = useGlotaT('spa.chat.modals.doNotMoveWallet');
  const cancelText = useGlotaT('spa.common.cancel');
  const forwardText = useGlotaT('spa.chat.modals.forward');
  const summaryTipText = useGlotaT('spa.chat.modals.summaryTip');

  const {
    handleGenerateSummary,
    handlePublishSummary,
    isGeneratingSummary,
    isLoading,
  } = useSummarize();

  const handleClose = () => {
    closeTransferChatModal();
    setOperator(null);
    setSelectedUserName('');
    setDepartment(null);
    setTextAreaValue('');
    setSummary(null);
    setSummaryError({
      status: 200,
      message: '',
    });
  };

  useEffect(() => {
    if (
      forwardChatWithSummary?.summary === undefined ||
      !forwardChatWithSummary?.summary
    )
      return;
    setTransferWithSummary(true);
  }, [forwardChatWithSummary, isOpen]);

  /**
   * O que fazer se alterar selectedOperator
   */
  useEffect(() => {
    // Resetando scrool ao selecionar um operador
    setObserverScroll(false);
    pageFull = 1;

    // Usuario Selecionado para mostrar no label do input
    if (usersOriginal && usersOriginal.length > 0) {
      const foundUser = usersOriginal.find((e) => e.id == selectedOperator);
      if (foundUser) setSelectedUserName(foundUser.name);
    }
  }, [selectedOperator]);
  /* End */

  const handleTransferWithSummary = useCallback(() => {
    if (transferWithSummary && !summary) {
      const now = new Date();
      const sevenDaysAgo = subDays(now, 7);
      handleGenerateSummary(
        opennedChat,
        {
          startDate: sevenDaysAgo.toISOString(),
          endDate: now.toISOString(),
        },
        false
      ).then((summary) => {
        if (summary?.status !== 200) {
          setTransferWithSummary(false);
          if (summary?.status === 404) {
            setSummaryError({
              status: 404,
              message: insufficientMessagesForSummaryText,
            });
          } else {
            setSummaryError({
              status: 500,
              message: 'Erro ao gerar o resumo de conversa.',
            });
          }
          return;
        }
        setSummary(summary.data);
        setTextAreaValue(summary.data?.summary);
        setInitialTextAreaValue(summary.data?.summary);
      });
    } else if (transferWithSummary && summary) {
      if (textAreaValue?.length > 0) {
        setTextAreaValue(textAreaValue);
        setInitialTextAreaValue(textAreaValue);
        return;
      }
      setTextAreaValue(summary?.summary);
      setInitialTextAreaValue(summary?.summary);
    }
  }, [
    forwardChatWithSummary?.summary,
    loadingSummary,
    transferWithSummary,
    isOpen,
    summary,
  ]);

  useEffect(() => {
    if (!isOpen) return;
    getSummary();
  }, [isOpen]);

  useEffect(() => {
    if (
      forwardChatWithSummary?.summary === undefined ||
      !forwardChatWithSummary?.summary ||
      !ia_fowarding_with_resume ||
      !isOpen
    ) {
      return;
    }
    handleTransferWithSummary();
  }, [isOpen]);

  useEffect(() => {
    if (!ia_fowarding_with_resume || !isOpen) return;
    handleTransferWithSummary();
  }, [transferWithSummary]);

  const onTransferChatRequest = () => {
    let wallet = [];

    if (walletOption === 0 || walletOption === null) {
      wallet.push(selectedOperator);
    } else if (walletOption === 1) {
      wallet.push(selectedOperator);
      if (opennedChat.chat?.origin_id) wallet.push(opennedChat.chat.origin_id);
    } else if (walletOption === 2) {
      wallet = [];
    }

    let data = {
      operator_id: selectedOperator,
      contact_id: opennedChat.id,
      department_id: selectedDepartment,
      wallet: wallet,
    };

    transferChatRequest(data);

    updateSummary(transferWithSummary);

    if (ia_fowarding_with_resume && transferWithSummary) {
      const now = new Date();
      const sevenDaysAgo = subDays(now, 7);

      const summaryToPublish = {
        ...summary,
        summary: textAreaValue,
      };

      handlePublishSummary(opennedChat, summaryToPublish, {
        startDate: sevenDaysAgo.toISOString(),
        endDate: now.toISOString(),
      });
    }
  };

  /**
   * Campo de pesquisa e toda a logica de pesquisa do atendente
   */
  const [currentValueSearch, setCurrentValueSearch] = useState('');
  const [lastTimeout, setLastTimeout] = useState(0);
  const [loadingSearch, setLoadingSearch] = useState(false);

  const onUpdateSearchValue = (value) => {
    setLoadingSearch(true);
    setUsers([]);

    if (lastTimeout) {
      clearTimeout(lastTimeout);
    }

    setCurrentValueSearch(value);

    setLastTimeout(
      setTimeout(() => {
        setLoadingSearch(false);
        searchList(value);
      }, 1000)
    );
  };

  const searchList = (value = '') => {
    if (usersOriginal && usersOriginal.length) {
      const result = usersOriginal.filter((item) => {
        return removeAccentString(item.name.toLowerCase()).includes(
          removeAccentString(value?.toLowerCase())
        );
      });

      setUsers(result);
      loadingListPage();
    }
  };

  const searchRender = (
    <div className="transfer-chat-search">
      <InputSearch
        onChange={(e) => onUpdateSearchValue(e.target.value)}
        value={currentValueSearch}
        loading={loadingSearch}
        placeholder=""
        clearSearch={onUpdateSearchValue}
      />
    </div>
  );

  const notUsersRender = () => {
    if (loadingSearch) {
      return (
        <p className="text-center">
          <small>{searchingText}</small>
        </p>
      );
    }

    if (users && users.length > 0) {
      return '';
    } else if (currentValueSearch?.toString()?.length > 0) {
      return (
        <p className="text-center">
          <small>{noResultsFoundText}</small>
        </p>
      );
    } else {
      return (
        <p className="text-center">
          <small>{noAttendantsRegisteredText}</small>
        </p>
      );
    }
  };
  /* End - Search */

  const userAndWalletData = isFetchingData ? (
    <div className="transfer-chat-loading">
      <small className="transfer-chat-loading-small">
        {' '}
        {waitLoadingInfoText}
      </small>
      <Animation icon="loading" size={'tiny'} />
    </div>
  ) : (
    <>
      <div className={`${selectedOperator ? 'transfer-chat-content' : ''}`}>
        <div className="transfer-chat-subsection operators">
          <FormGroup className="transfer-chat-subgroup">
            {selectedOperator && (
              <>
                <span className="transfer-chat-subtitle">
                  {checkForwardingInfoText}
                </span>
              </>
            )}
            <UncontrolledDropdown className="transf-chats">
              <Label for="operators" className="transfer-chat-label">
                {attendantsText}
              </Label>
              <DropdownToggle
                color="neutral"
                disabled={isLoading}
                caret
                id="operators"
                name="operators"
                className="transfer-option-name total"
                onClick={(e) => {
                  setObserverScroll(true);
                }}
                onChange={(e) => {
                  if (e.target.value) {
                    setOperator(parseInt(e.target.value));
                  }
                }}
              >
                <span className="nameoperator">
                  {' '}
                  {selectedUserName && selectedUserName.toString()?.length > 0
                    ? selectedUserName
                    : selectAttendantToForwardText}
                </span>
              </DropdownToggle>
              <DropdownMenu className="w-100 dropdown-menu-transfer-chat">
                {searchRender}
                {notUsersRender()}

                <div
                  className="transfer-chats-dropdown"
                  id="listTransferScroll"
                >
                  {loadingListTop && <Animation icon="loading" size={'tiny'} />}

                  {/* Renderizazando lista de acordo com scroll */}
                  {usersToShow.map((e, i) => {
                    if (i > pageFull - limitePage && i < pageFull) return e;
                  })}

                  {loadingListDown && (
                    <Animation icon="loading" size={'tiny'} />
                  )}
                </div>
              </DropdownMenu>
            </UncontrolledDropdown>
            {selectedOperator &&
              ia_fowarding_with_resume &&
              summaryError.status !== 404 && (
                <div className="d-flex flex-column">
                  <Label for="real-textarea" className="transfer-chat-label">
                    {aiSummaryText}
                  </Label>
                  {transferWithSummary &&
                  !isGeneratingSummary &&
                  summaryError.status === 200 ? (
                    <div className="scroll-container" id="real-textarea">
                      <div
                        className="gradient-text"
                        contentEditable={true}
                        suppressContentEditableWarning={true}
                        onInput={(e) => {
                          setTextAreaValue(e.currentTarget.textContent);
                        }}
                      >
                        {initialTextAreaValue}
                      </div>
                    </div>
                  ) : isGeneratingSummary && transferWithSummary ? (
                    <div
                      className="relative false-text-area-tips"
                      id="real-textarea"
                    >
                      <div className="loading-summary">
                        <Animation icon="loading" size={'tiny'} />
                      </div>
                    </div>
                  ) : (
                    <span className="false-text-area-tips" id="real-textarea">
                      {summaryTipText}
                    </span>
                  )}
                </div>
              )}

            {ia_fowarding_with_resume && selectedOperator && (
              <FormGroup check className="wrapper-transfer-with-summary">
                <CustomInput
                  id="transfer-with-summary"
                  type="checkbox"
                  disabled={summaryError.status === 404}
                  value={transferWithSummary}
                  label={forwardWithSummaryText}
                  checked={transferWithSummary}
                  onChange={() => {
                    if (summaryError.status === 404) return;
                    setTransferWithSummary(!transferWithSummary);
                  }}
                />
                <Info id="transfer-with-summary-info" width={16} height={16} />
                <UncontrolledTooltip
                  placement="right"
                  target="transfer-with-summary-info"
                >
                  {summaryTooltipText}
                </UncontrolledTooltip>
              </FormGroup>
            )}
          </FormGroup>
        </div>

        {showWalletOptions && (
          <div className="transfer-chat-subsection wallet">
            <FormGroup className="transfer-chat-subgroup">
              <Label for="wallet" className="transfer-chat-label">
                {walletRedirectText}
              </Label>

              <FormGroup className="form-check-custom" check>
                <Label check for="wallet0"></Label>
                <CustomInput
                  className="transfer-chat-label-custom"
                  label={toUserWalletText}
                  id="wallet0"
                  type="radio"
                  checked={
                    walletOption === '0' ||
                    walletOption === null ||
                    walletOption === 0
                  }
                  onChange={(e) => {
                    if (e.target.value)
                      setWalletOption(parseInt(e.target.value));
                  }}
                  name="wallet"
                  value="0"
                />
              </FormGroup>

              <FormGroup className="form-check-custom" check>
                <Label check for="wallet1"></Label>

                <CustomInput
                  className="transfer-chat-label-custom"
                  label={duplicateUserWalletText}
                  id="wallet1"
                  type="radio"
                  name="wallet"
                  value="1"
                  checked={walletOption === '1'}
                  onChange={(e) => {
                    if (e.target.value)
                      setWalletOption(parseInt(e.target.value));
                  }}
                />
              </FormGroup>

              <FormGroup className="form-check-custom" check>
                <Label check for="wallet2"></Label>

                <CustomInput
                  className="transfer-chat-label-custom"
                  label={doNotMoveWalletText}
                  id="wallet2"
                  type="radio"
                  name="wallet"
                  value="2"
                  checked={walletOption === '2'}
                  onChange={(e) => {
                    if (e.target.value)
                      setWalletOption(parseInt(e.target.value));
                  }}
                />
              </FormGroup>
            </FormGroup>
          </div>
        )}
      </div>

      <div
        className={
          selectedOperator
            ? 'transfer-chat-buttons-subsection-row'
            : 'transfer-chat-buttons-subsection'
        }
        style={{
          display: 'flex',
          flexDirection: 'row',
          gap: '1rem',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <button
          className="btn btn-primary w-100"
          disabled={isLoading}
          onClick={() => handleClose()}
        >
          {cancelText}
        </button>
        <button
          className="btn btn-primary btn-transfer-chat w-100"
          disabled={
            !selectedOperator ||
            opennedChat?.transfering ||
            isLoading ||
            isGeneratingSummary ||
            (textAreaValue?.length === 0 &&
              transferWithSummary &&
              ia_fowarding_with_resume)
          }
          onClick={() => {
            onTransferChatRequest();
          }}
          style={{
            '&hover': {
              backgroundColor: 'var(--primary) !important',
            },
          }}
        >
          {opennedChat?.transfering ? (
            <Animation icon="loading" size={'minorLittleTiny'} />
          ) : (
            forwardText
          )}
        </button>
      </div>
    </>
  );

  return (
    <Modal
      isOpen={isOpen}
      toggle={handleClose}
      contentClassName="transfer-chat-modal"
      id="transfer-chat-modal"
    >
      <div className="wrapper-title-transfer-chat">
        <span className="transfer-chat-title">{forwardChatText}</span>
        <Button color="link" onClick={() => handleClose()} disabled={isLoading}>
          <Close width={12} height={12} />
        </Button>
      </div>

      {userAndWalletData}
    </Modal>
  );
}

const mapStateToProps = (state) => ({
  chat: state.chat,
  currentUser: state.chat?.config?.user,
  allOperators: state.chat?.config?.general?.users,
  allDepartments: state.chat?.config?.general?.departments,
  current_customer_id: state.general?.current_customer_id,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(ChatActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(TransferChatModal);
